/*--------------------------------------------------
 NAVIGATION
---------------------------------------------------*/
!(function () {
  window.onload = function () {
    o.init(),
      document.fonts.ready.then(function () {
        n.init(),
          feather.replace(),
          (function () {
            let e = gsap.timeline();
            e.preloaderInitial(), (e = s.init(e));
          })();
      });
  };
  $("#nav-filter button").on("click", function () {
    $("#nav-filter button").removeClass("filter-active"),
      $(this).addClass("filter-active"),
      i.isotope({ filter: $(this).data("filter") });
  }),
    $(".element-item").on({
      mouseenter: function () {
        $(".element-item").not($(this)).addClass("active-item");
      },
      mouseleave: function () {
        $(".element-item").not($(this)).removeClass("active-item");
      },
    }),
    $(".jarallax").jarallax({ speed: 0.7 });
  GLightbox({ touchNavigation: !0, loop: !1, autoplayVideos: !0 });
  (window.App = {}), (App.html = document.querySelector("html"));
  const n = (function () {
      let e,
        t,
        i,
        n,
        o,
        s,
        a,
        r,
        l,
        c = gsap.timeline();
      function d(e) {
        e
          ? gsap.to(r, {
              ease: "quart.inOut",
              duration: 0.6,
              y: "0px",
              opacity: 1,
              onStart: () => {
                r.classList.remove("pointer-events-none");
              },
            })
          : gsap.to(r, {
              ease: "quart.inOut",
              duration: 0.6,
              opacity: 0,
              onStart: () => {
                r.classList.add("pointer-events-none");
              },
            });
      }
      function u(e, t) {
        const i = document.querySelector(".js-nav-close");
        let n = e.children;
        n = Array.from(n);
        const o = n.map((e) => e.querySelector("li > a"));
        let s = t.children;
        s = Array.from(s);
        const a = s.map((e) => e.querySelector("li > a"));
        c.clear()
          .to(o, {
            ease: "quart.out",
            stagger: -0.04,
            duration: 1,
            y: "100%",
            onStart: () => {
              t.classList.add("is-visible"),
                e.classList.remove("is-visible"),
                i.classList.add("pointer-events-none");
            },
          })
          .to(
            a,
            {
              ease: "quart.out",
              stagger: 0.08,
              duration: 1.2,
              y: "0%",
              onComplete: () => {
                i.classList.remove("pointer-events-none");
              },
            },
            ">-0.6"
          );
      }
      return {
        init: function () {
          (e = document.querySelector(".js-nav-inner")),
            (t = e.querySelector(".js-nav-bg")),
            (i = e.querySelector(".js-navList")),
            (n = e.querySelectorAll(".js-navList > li > a")),
            (o = e.querySelectorAll(".js-navInfo-item")),
            (s = document.querySelector(".js-nav-open")),
            (a = document.querySelector(".js-nav-close")),
            (r = document.querySelector(".js-nav-back")),
            (l = 0),
            (function () {
              const e = document.querySelectorAll(
                ".js-navList .menu-item-has-children"
              );
              if (!e.length) return;
              r.addEventListener("click", () => {
                const e = i.querySelector("ul.is-visible"),
                  t = e.parentElement.parentElement;
                l--, d(l), u(e, t);
              }),
                e.forEach((e) => {
                  const t = e.querySelector("li > a");
                  t.removeAttribute("href"),
                    t.addEventListener("click", () => {
                      const t = e.parentElement,
                        i = e.lastElementChild;
                      l++, d(l), u(t, i);
                    });
                });
            })(),
            (function () {
              if (!s) return;
              s.addEventListener("click", () => {
                e.classList.add("is-active"),
                  gsap
                    .timeline()
                    .set(n, { opacity: 1 })
                    .set(r, { opacity: 0 })
                    .fromTo(
                      t,
                      { scaleY: 0 },
                      { scaleY: 1, duration: 0.8, ease: "quart.inOut" }
                    )
                    .fromTo(
                      a,
                      { y: "16px", opacity: 0 },
                      {
                        ease: "quart.out",
                        duration: 0.8,
                        y: "0px",
                        opacity: 1,
                      },
                      ">-0.2"
                    )
                    .fromTo(
                      n,
                      { y: "100%" },
                      {
                        ease: "quart.out",
                        stagger: 0.08,
                        duration: 1.2,
                        y: "0%",
                      },
                      ">-0.7"
                    )
                    .fromTo(
                      o,
                      { opacity: 0, y: "34px" },
                      {
                        ease: "quart.out",
                        stagger: 0.08,
                        duration: 1,
                        opacity: 1,
                        y: "0px",
                        onComplete: () => {
                          i.classList.add("is-visible"),
                            a.classList.remove("pointer-events-none");
                        },
                      },
                      "<"
                    );
              }),
                a.addEventListener("click", () => {
                  !(function () {
                    const i = e.querySelector(".is-visible"),
                      n = e.querySelectorAll(".is-visible > li > a");
                    (l = 0),
                      (document.getElementById("body-id").style.overflowY = ""),
                      gsap
                        .timeline()
                        .to([a, r], {
                          ease: "quart.out",
                          duration: 0.6,
                          opacity: 0,
                          y: "-16px",
                          onStart: () => {
                            a.classList.add("pointer-events-none"),
                              i.classList.remove("is-visible"),
                              t.classList.add("origin-top");
                          },
                        })
                        .to(
                          n,
                          { ease: "quart.out", duration: 0.8, y: "-100%" },
                          ">-0.4"
                        )
                        .to(
                          o,
                          {
                            opacity: 0,
                            y: "-34px",
                            ease: "quart.out",
                            duration: 0.8,
                          },
                          "<"
                        )
                        .to(
                          t,
                          {
                            ease: "quart.inOut",
                            duration: 0.8,
                            scaleY: 0,
                            onComplete: () => {
                              s.classList.remove("pointer-events-none"),
                                t.classList.remove("origin-top"),
                                e.classList.remove("is-active");
                            },
                          },
                          ">-0.6"
                        );
                  })();
                });
            })();
        },
      };
    })(),
    o = (function () {
      const e = document.querySelector(".js-preloader"),
        t = e.querySelector(".preloader__bg"),
        i = e.querySelector(".preloader__progress"),
        n = e.querySelector(".preloader__progress__inner");
      return {
        init: function () {
          e &&
            (gsap.registerEffect({
              name: "preloaderInitial",
              effect: (e, o) => {
                const s = gsap.timeline();
                return (
                  document.documentElement.classList.add(
                    "html-overflow-hidden"
                  ),
                  document.body.classList.contains("preloader-visible")
                    ? s
                        .fromTo(
                          n,
                          { scaleY: 0 },
                          {
                            scaleY: 1,
                            ease: "none",
                            duration: 1,
                            delay: 0.1,
                            onStart: () => {
                              t.classList.add("origin-top");
                            },
                          }
                        )
                        .to(
                          i,
                          {
                            duration: 0.5,
                            ease: "quart.inOut",
                            opacity: 0,
                            scale: 0.75,
                          },
                          ">-0.1"
                        )
                        .to(
                          t,
                          {
                            ease: "quart.inOut",
                            duration: 0.6,
                            scaleY: 0,
                            onComplete: () => {
                              document.documentElement.classList.remove(
                                "html-overflow-hidden"
                              );
                            },
                          },
                          ">-0.5"
                        )
                    : (document.documentElement.classList.remove(
                        "html-overflow-hidden"
                      ),
                      s)
                );
              },
              extendTimeline: !0,
            }),
            gsap.registerEffect({
              name: "preloaderShow",
              effect: (o, s) => {
                const a = gsap.timeline();
                return e
                  ? (a
                      .set(i, { opacity: 0, scale: 0.75 })
                      .set(n, { scaleY: 0 })
                      .to(t, {
                        ease: "quart.inOut",
                        duration: 0.6,
                        scaleY: 1,
                        onStart: () => {
                          t.classList.remove("origin-top"),
                            document.documentElement.classList.add(
                              "html-overflow-hidden"
                            );
                        },
                      })
                      .to(i, {
                        delay: 0.1,
                        duration: 0.6,
                        ease: "quart.out",
                        opacity: 1,
                        scale: 1,
                      })
                      .to(n, { scaleY: 1, duration: 1, ease: "none" }, ">-0.3"),
                    a)
                  : a;
              },
              extendTimeline: !0,
            }),
            gsap.registerEffect({
              name: "preloaderHide",
              effect: (e, n) =>
                gsap
                  .timeline()
                  .to(i, {
                    delay: 0.15,
                    duration: 0.5,
                    ease: "quart.inOut",
                    opacity: 0,
                    scale: 0.75,
                    onStart: () => {
                      t.classList.add("origin-top");
                    },
                  })
                  .to(
                    t,
                    {
                      ease: "quart.inOut",
                      duration: 0.6,
                      scaleY: 0,
                      onComplete: () => {
                        document.documentElement.classList.remove(
                          "html-overflow-hidden"
                        ),
                          document.documentElement.classList.remove(
                            "overflow-hidden"
                          ),
                          document.body.classList.remove("overflow-hidden");
                      },
                    },
                    ">-0.5"
                  ),
              extendTimeline: !0,
            }));
        },
      };
    })();
  const s = {
    init: function (e) {
      return e;
    },
  };
})();

/*--------------------------------------------------
  LAZY LOAD
---------------------------------------------------*/

var lazyLoadInstance = new LazyLoad({
  elements_selector: ".js-lazy",
});

/*--------------------------------------------------
  CUSTOM CURSOR
---------------------------------------------------*/

document.addEventListener("mousemove", function (e) {
  const root = document.documentElement;
  root.style.setProperty("--mouse-x", `${e.clientX}px`);
  root.style.setProperty("--mouse-y", `${e.clientY}px`);
});

/*--------------------------------------------------
 VIDEO PLAY/PAUSE
---------------------------------------------------*/
// Get the video and button elements
const videoElement = $("#hero-vid");
const pauseButton = $("#pause-btn");

// Add click event listener to the pause button
pauseButton.on("click", function () {
  // Toggle play/pause state of the video
  const isPlaying = !videoElement.prop("paused");
  videoElement.trigger(isPlaying ? "pause" : "play");

  // Update button icon and accessible label based on video state
  const iconClass = isPlaying ? "fa-play" : "fa-pause";
  const altText = isPlaying ? "play video" : "pause video";
  $(this).html(`<i class="fa-solid ${iconClass}" aria-label="${altText}"></i>`);
});

/*--------------------------------------------------
  SWIPER SLIDERS
---------------------------------------------------*/

new Swiper(".swiper-tile", {
  spaceBetween: 30,
  loop: !1,
  autoHeight: !0,
  slidesPerView: 1,
  keyboard: { enabled: !0 },
  navigation: { nextEl: ".button-next", prevEl: ".button-prev" },
  breakpoints: {
    414: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 2, spaceBetween: 20 },
    768: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 30 },
    1200: { slidesPerView: 4, spaceBetween: 30 },
    1680: { slidesPerView: 4, spaceBetween: 30 },
  },
  pagination: {
    el: ".js-pagination",
    bulletClass: "pagination__item",
    bulletActiveClass: "is-active",
    clickable: true,
  },
}),
  new Swiper(".swiper-student-testimonials", {
    slidesPerView: "1",
    spaceBetween: 30,
    loop: !1,
    grabCursor: !0,

    pagination: {
      el: ".js-pagination",
      bulletClass: "pagination__item",
      bulletActiveClass: "is-active",
      clickable: true,
    },

    keyboard: { enabled: !0 },
  });

var swiper = new Swiper(".js-section-slider", {
  slidesPerView: 3,
  spaceBetween: 40,
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  autoHeight: true,
  loop: false,

  pagination: {
    el: ".js-pagination",
    bulletClass: "pagination__item",
    bulletActiveClass: "is-active",
    clickable: true,
  },

  navigation: { nextEl: ".button-next", prevEl: ".button-prev" },
});

// After initializing the swiper
if (swiper.slides.length <= 3) {
  // If there are 3 or fewer slides, add the 'd-none' class to the pagination
  $(swiper.pagination.el).addClass("d-none");
} else {
  // If there are more than 3 slides, remove the 'd-none' class from the pagination
  $(swiper.pagination.el).removeClass("d-none");
}

// Listen for window resize events
window.addEventListener("resize", function () {
  // If the window width is less than 1024px
  if (window.matchMedia("(max-width: 1025px)").matches) {
    // Remove the 'd-none' class from the pagination
    $(swiper.pagination.el).removeClass("d-none");
  } else {
    // If there are 3 or fewer slides, add the 'd-none' class back to the pagination
    if (swiper.slides.length <= 3) {
      $(swiper.pagination.el).addClass("d-none");
    }
  }
});

/*--------------------------------------------------
 INSTITUTION FILTER
---------------------------------------------------*/

let i = $(".institution-container").isotope({
  itemSelector: ".element-item",
  layoutMode: "vertical",
});

/*--------------------------------------------------
 TAB NAVIGATION FIX
---------------------------------------------------*/

isTabNav = 0;

document
  .getElementById("tabDetectMe")
  .addEventListener("keyup", function (event) {
    if (event.key === "Tab" && isTabNav === 0) {
      tabNav();
      console.log("Simplify Navigation");
      isTabNav = 1;
    }
  });

document
  .getElementById("tabDetectClose")
  .addEventListener("keydown", function (event) {
    if (event.key === "Tab" && isTabNav === 0) {
      tabNav();
      console.log("Simplify Navigation");
      isTabNav = 1;
    }
  });

document.body.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    document.getElementById("tabDetectClose").click();
  }
});

function openSimpleNavigation() {
  document.getElementById("tabReplaceMe").parentElement.classList.add("showMe");
}

function closeSimpleNavigation() {
  document
    .getElementById("tabReplaceMe")
    .parentElement.classList.remove("showMe");
}

function tabNav() {
  navigation = document.getElementById("tabReplaceMe");
  newHTML = document.getElementById("tabReplaceMe");
  document
    .getElementById("tabReplaceMe")
    .setAttribute("class", "simpleNavigation");

  stripClass = newHTML.querySelectorAll("*");
  stripClass.forEach(function (element) {
    element.removeAttribute("class");
    element.classList.add("is-visible");
  });

  stripEmptyLinks = newHTML.querySelectorAll('[role="button"]');
  stripEmptyLinks.forEach(function (element) {
    headerText = element.innerHTML;
    element.outerHTML = headerText;
  });

  navigation.innerHTML = newHTML.innerHTML;
}

/*--------------------------------------------------
 HOVER EFFECTS
---------------------------------------------------*/

//
document.querySelectorAll(".portfolioCard.-hover").forEach((card) => {
  card.addEventListener("mouseover", () => {
    card.querySelector(".portfolioCard__img__inner").style.transform =
      "scale(1.1)";
    card.querySelector(".portfolioCard__title").style.color = "#ff5733";
  });
  card.addEventListener("mouseout", () => {
    card.querySelector(".portfolioCard__img__inner").style.transform =
      "scale(1)";
    card.querySelector(".portfolioCard__title").style.color = "";
  });
});

/*--------------------------------------------------
 Reveal & Hide Elements
---------------------------------------------------*/

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const elements = gsap.utils.toArray(".slide-up");

  elements.forEach((element, index) => {
    gsap.fromTo(
      element,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: "Expo.easeOut",
        delay: index * 0.1, // Staggering effect by delaying each element
        scrollTrigger: {
          trigger: element,
          start: "top 95%",
          toggleActions: "play none none none",
        },
      }
    );
  });
});

function wrapWithLineContainer(elements) {
  elements.forEach((element) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("line-container");
    element.parentNode.insertBefore(wrapper, element);
    wrapper.appendChild(element);
  });
}

function animateLines(elements) {
  wrapWithLineContainer(elements);
  const innerElements = document.querySelectorAll(".line-container > *");
  gsap.set(innerElements, { y: "100%" }); // Set initial state
  gsap.to(innerElements, {
    y: "0%",
    duration: 0.6, //Speed up animation
    delay: 2.2,
    ease: "power2.out",
    stagger: 0.1,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const elementsToAnimate = document.querySelectorAll(
    '[data-split="lines"][data-split-page-reveal]'
  );
  animateLines(elementsToAnimate);
});


/*--------------------------------------------------
 For Tooltip on RFI form
---------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function () {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
});

/*--------------------------------------------------
 Navigation Reveal and hide using Headroom.js
---------------------------------------------------*/
(function () {
  var header = document.querySelector("#sticky-header");

  var headroom = new Headroom(header, {
    tolerance: {
      down: 10,
      up: 20
    },
    offset: 15
  });
  headroom.init();
})();
